module.exports = __webpack_public_path__ + "img/LogoLoading_circle01.8143d571.png";